module.exports = __webpack_public_path__ + "img/team6.3aeb2338.jpg";